import ScrollTrigger from "gsap/ScrollTrigger";
import gsap from "gsap";

// Register the ScrollTrigger plugin with GSAP
gsap.registerPlugin(ScrollTrigger);

// Define the footer element
const footer = document.getElementById("footer");

// Set up the ScrollTrigger to animate the footer's background color based on scroll position
gsap.to(footer, {
	backgroundColor: "#00535E",
	scrollTrigger: {
		trigger: footer,
		start: "top 75%",
		end: "bottom 100%",
		scrub: 0.25,
		markers: false,
	},
});
